import { categoryImages } from "@/mocks/categories";
import { categories } from "@/mocks/categories";

interface CategorySectionProps {
  limit?: number;
  showAll?: boolean;
}

const categoryLabels = [
  "Shoes", "Hoodies / Sweaters", "T-Shirts", "Jackets",
  "Pants / Shorts", "Headwear", "Sets", "Bags",
  "Underwear", "Jersey", "Accessories", "Belts",
  "Perfumes", "Other Stuff",
];

export default function CategorySection({ limit, showAll }: CategorySectionProps) {
  const displayImages = limit ? categoryImages.slice(0, limit) : categoryImages;
  const displayCount = limit || categoryImages.length;

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="px-6 md:px-12">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Shop by Category
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Browse our curated collections of the best superbuy spreadsheet finds across every category
          </p>
        </div>

        {/* Mobile horizontal scroll */}
        <div className="md:hidden flex gap-4 overflow-x-auto pb-4 scrollbar-hide -mx-2 px-2">
          {displayImages.slice(0, displayCount).map((img, i) => (
            <a
              key={i}
              href={categories[i]?.url || "https://kaspreadsheet.com/"}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-40 group cursor-pointer"
            >
              <div className="relative w-full aspect-square rounded-xl overflow-hidden bg-background-100">
                <img
                  src={img}
                  alt={categoryLabels[i] || "Product category"}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <p className="text-sm font-semibold text-background-50">{categoryLabels[i]}</p>
                  <p className="text-xs text-background-50/70 mt-0.5">Browse &rarr;</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Desktop grid */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-5">
          {displayImages.slice(0, displayCount).map((img, i) => (
            <a
              key={i}
              href={categories[i]?.url || "https://kaspreadsheet.com/"}
              target="_blank"
              rel="noopener nofollow"
              className="group cursor-pointer rounded-xl overflow-hidden bg-background-100 hover:shadow-md transition-all duration-300"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden">
                <img
                  src={img}
                  alt={categoryLabels[i] || "Product category"}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/55 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <p className="text-base font-semibold text-background-50">{categoryLabels[i]}</p>
                  <p className="text-xs text-background-50/70 mt-1">View Collection &rarr;</p>
                </div>
              </div>
            </a>
          ))}
        </div>

        {showAll && (
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {["Underwear", "Jersey", "Accessories", "Belts", "Perfumes", "Other Stuff"].map((name) => (
              <a
                key={name}
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-3 bg-background-100 hover:bg-accent-100 rounded-lg text-sm text-center font-medium text-foreground-700 hover:text-accent-800 transition-all cursor-pointer whitespace-nowrap"
              >
                {name}
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}